<template>
  <div class="p-0 m-0">
    <h1 class="mt-2 text-2xl font-bold mb-6 text-gray-800">Dashboard</h1>

    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <!-- MyMessages Component -->
      <div class="lg:col-span-1">
        <MyMessages @view-message="handleViewMessage" />
      </div>

      <!-- Leave requests for selected date range -->
      <div v-if="canViewLeaves" class="lg:col-span-1">
        <DashboardLeaveRequests />
      </div>
    </div>
  </div>
</template>

<script>
import MyMessages from './MyMessages.vue'
import DashboardLeaveRequests from './DashboardLeaveRequests.vue'
import { canViewLeaveDashboard } from '@/utils/leave'

export default {
  name: 'Dashboard',
  components: {
    MyMessages,
    DashboardLeaveRequests,
  },
  computed: {
    canViewLeaves() {
      return canViewLeaveDashboard(this.$store.getters['authentication/currentUser']?.role);
    },
  },
  methods: {
    handleViewMessage(message) {
      // Handle message viewing logic here
      console.log('Viewing message:', message);
      // You can implement modal, navigation, or other actions here
    }
  },
}
</script>
